 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];
 		var prefetchChunks = data[3] || [];
 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);
 		deferredPrefetch.push.apply(deferredPrefetch, prefetchChunks);
 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}
 		if(deferredModules.length === 0) {
 			// chunk prefetching for javascript
 			deferredPrefetch.forEach(function(chunkId) {
 				if(installedChunks[chunkId] === undefined) {
 					installedChunks[chunkId] = null;
 					var link = document.createElement('link');

 					if (__webpack_require__.nc) {
 						link.setAttribute("nonce", __webpack_require__.nc);
 					}
 					link.rel = "prefetch";
 					link.as = "script";
 					link.href = jsonpScriptSrc(chunkId);
 					document.head.appendChild(link);
 				}
 			});
 			deferredPrefetch.length = 0;
 		}
 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [], deferredPrefetch = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"3rd-libs":"3rd-libs","MyProfile":"MyProfile","notifications":"notifications","design":"design","default~edit-item-mod~4fd868ff":"default~edit-item-mod~4fd868ff","superadmin-accounts":"superadmin-accounts","superadmin-finance":"superadmin-finance","default~addons~cloud-~ff286050":"default~addons~cloud-~ff286050","addons":"addons","integrations":"integrations","ordering":"ordering","my-menu":"my-menu","cloud":"cloud","surveys":"surveys","modifiers":"modifiers","coupons":"coupons","bulk-menu":"bulk-menu","custom-inputs":"custom-inputs","dashboard-api":"dashboard-api","default~google~map":"default~google~map","google":"google","design-localizations":"design-localizations","domain":"domain","dynamicLinks":"dynamicLinks","feather":"feather","kitchen":"kitchen","lang-az-json":"lang-az-json","lang-bg-json":"lang-bg-json","lang-bn-BD-json":"lang-bn-BD-json","lang-ca-json":"lang-ca-json","lang-de-json":"lang-de-json","lang-el-json":"lang-el-json","lang-es-json":"lang-es-json","lang-et-json":"lang-et-json","lang-fa-json":"lang-fa-json","lang-fi-json":"lang-fi-json","lang-fil-json":"lang-fil-json","lang-fr-json":"lang-fr-json","lang-ha-json":"lang-ha-json","lang-hi-json":"lang-hi-json","lang-hr-json":"lang-hr-json","lang-hu-json":"lang-hu-json","lang-hy-json":"lang-hy-json","lang-it-json":"lang-it-json","lang-ja-json":"lang-ja-json","lang-ka-json":"lang-ka-json","lang-kk-json":"lang-kk-json","lang-km-json":"lang-km-json","lang-ko-json":"lang-ko-json","lang-ku-json":"lang-ku-json","lang-lo-json":"lang-lo-json","lang-mn-json":"lang-mn-json","lang-ms-json":"lang-ms-json","lang-nb-json":"lang-nb-json","lang-nl-json":"lang-nl-json","lang-pl-json":"lang-pl-json","lang-pt-json":"lang-pt-json","lang-ro-json":"lang-ro-json","lang-ru-json":"lang-ru-json","lang-sq-json":"lang-sq-json","lang-sv-json":"lang-sv-json","lang-th-json":"lang-th-json","lang-ur-json":"lang-ur-json","lang-vi-json":"lang-vi-json","lang-zh-json":"lang-zh-json","multiselect":"multiselect","ok-table":"ok-table","b2b":"b2b","superadmin-addons":"superadmin-addons","superadmin-integrations":"superadmin-integrations","superadmin-marketing":"superadmin-marketing","qr":"qr","superadmin":"superadmin","date-picker":"date-picker","statistics":"statistics","default~billing~super~e4f9bc0f":"default~billing~super~e4f9bc0f","discounts":"discounts","reports":"reports","inventory":"inventory","clients":"clients","queues":"queues","reservations":"reservations","default~cloud-input~pos":"default~cloud-input~pos","pos":"pos","taxes":"taxes","phone-input":"phone-input","billing":"billing","refunds":"refunds","register":"register","default~custom-inputs~f3823b4b":"default~custom-inputs~f3823b4b","newsletters":"newsletters","shifts":"shifts","validate-lang-ar-json":"validate-lang-ar-json","validate-lang-bd-json":"validate-lang-bd-json","validate-lang-es-json":"validate-lang-es-json","validate-lang-fr-json":"validate-lang-fr-json","welcome":"welcome","widget":"widget","vue-cropper":"vue-cropper","vue-color":"vue-color","map":"map","delivery":"delivery","cloud-input":"cloud-input","import-modal":"import-modal","ok-editor":"ok-editor","default~edit-category~adbc22d8":"default~edit-category~adbc22d8","edit-category-modal":"edit-category-modal","edit-item-modal":"edit-item-modal","receipt-template":"receipt-template"}[chunkId]||chunkId) + "." + {"3rd-libs":"e6af75ac","MyProfile":"d1b8a472","chunk-594d6d48":"8a216641","notifications":"da1d6e10","chunk-b8565db6":"0cc0f6b3","chunk-dc20c3ac":"497455b7","design":"1b0e4360","default~edit-item-mod~4fd868ff":"679cee33","superadmin-accounts":"bb5d56d2","superadmin-finance":"6e71224f","default~addons~cloud-~ff286050":"6884ed14","addons":"418de94b","integrations":"f6dd2ef4","ordering":"968857f3","my-menu":"5a7e11eb","cloud":"45dacb19","surveys":"c89c3331","modifiers":"62ccf5a3","coupons":"326c854d","bulk-menu":"5b4c54ec","custom-inputs":"75701b71","dashboard-api":"39a5e7e8","default~google~map":"e8b759fb","google":"d6a00c74","design-localizations":"6a26af90","domain":"3d9ad6b0","dynamicLinks":"ffac8af0","feather":"04a56921","kitchen":"67d460ff","lang-az-json":"8ef3a5b4","lang-bg-json":"90f2f96d","lang-bn-BD-json":"75e9f696","lang-ca-json":"b0350813","lang-de-json":"d437f788","lang-el-json":"f31b1e2d","lang-es-json":"3afe4d57","lang-et-json":"954addd1","lang-fa-json":"b1883bed","lang-fi-json":"3b1e31ce","lang-fil-json":"22a5041a","lang-fr-json":"11856465","lang-ha-json":"6af93eda","lang-hi-json":"51a0bd6a","lang-hr-json":"2fc2e5c7","lang-hu-json":"9c4ebc0e","lang-hy-json":"4a8d1481","lang-it-json":"be87e676","lang-ja-json":"513592e8","lang-ka-json":"9c673d32","lang-kk-json":"b16339fe","lang-km-json":"0ad5e351","lang-ko-json":"9eea9ace","lang-ku-json":"c39ac9d2","lang-lo-json":"4c5eb2f2","lang-mn-json":"37fe8415","lang-ms-json":"0d7bb86f","lang-nb-json":"1529e1f1","lang-nl-json":"c0507f23","lang-pl-json":"6d3e687b","lang-pt-json":"bf7cb334","lang-ro-json":"f1ab6a1e","lang-ru-json":"883fe25c","lang-sq-json":"35e8db19","lang-sv-json":"abc8d4c6","lang-th-json":"c5f4d540","lang-ur-json":"cb6bd2fb","lang-vi-json":"d9f25375","lang-zh-json":"2f472c95","multiselect":"f5165d68","ok-table":"507526d7","b2b":"23463cea","superadmin-addons":"1430275a","superadmin-integrations":"6cd461c8","superadmin-marketing":"84e4ce66","qr":"3a7fa466","superadmin":"eb7a162b","date-picker":"7028ae6c","statistics":"2def2e40","default~billing~super~e4f9bc0f":"a9d881f5","discounts":"60a46f1d","reports":"bb065913","inventory":"ade7ff4e","clients":"6ed34a9a","queues":"b0807acb","reservations":"cb825a68","default~cloud-input~pos":"b65ad895","pos":"47a815e9","taxes":"e8278e85","phone-input":"97d56399","billing":"9e2a4263","refunds":"1102204e","register":"9c1b4891","default~custom-inputs~f3823b4b":"5b311975","newsletters":"8ee79542","shifts":"0d545a6c","validate-lang-ar-json":"5b001d21","validate-lang-bd-json":"39010a0e","validate-lang-es-json":"9efc67ed","validate-lang-fr-json":"0c28893c","welcome":"f616f491","widget":"792f79bd","vue-cropper":"b731941a","vue-color":"626ecd6b","map":"1ea12e6b","chunk-01d6075b":"e93272c1","delivery":"9b57b089","cloud-input":"a215b303","import-modal":"f45784ee","ok-editor":"7f502584","default~edit-category~adbc22d8":"00611038","edit-category-modal":"840e606f","edit-item-modal":"671a2c8d","chunk-0be90b42":"d8292fd0","chunk-2170a6e2":"27e2b2f3","chunk-79ad76c2":"af01b9cf","chunk-8a6fc05c":"6af1c417","chunk-5daf2e3a":"1a1fec23","chunk-6ec23fa8":"6d45254e","receipt-template":"8bb00218"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"3rd-libs":1,"MyProfile":1,"notifications":1,"design":1,"default~edit-item-mod~4fd868ff":1,"superadmin-accounts":1,"superadmin-finance":1,"addons":1,"integrations":1,"ordering":1,"my-menu":1,"cloud":1,"surveys":1,"modifiers":1,"coupons":1,"bulk-menu":1,"custom-inputs":1,"dashboard-api":1,"default~google~map":1,"google":1,"design-localizations":1,"domain":1,"dynamicLinks":1,"feather":1,"kitchen":1,"multiselect":1,"ok-table":1,"b2b":1,"superadmin-addons":1,"superadmin-integrations":1,"superadmin-marketing":1,"qr":1,"superadmin":1,"date-picker":1,"statistics":1,"default~billing~super~e4f9bc0f":1,"discounts":1,"reports":1,"inventory":1,"clients":1,"queues":1,"reservations":1,"pos":1,"taxes":1,"phone-input":1,"billing":1,"refunds":1,"register":1,"default~custom-inputs~f3823b4b":1,"newsletters":1,"shifts":1,"validate-lang-ar-json":1,"welcome":1,"widget":1,"vue-cropper":1,"vue-color":1,"map":1,"chunk-01d6075b":1,"delivery":1,"cloud-input":1,"import-modal":1,"ok-editor":1,"default~edit-category~adbc22d8":1,"edit-category-modal":1,"edit-item-modal":1,"chunk-0be90b42":1,"chunk-2170a6e2":1,"chunk-79ad76c2":1,"chunk-8a6fc05c":1,"chunk-5daf2e3a":1,"chunk-6ec23fa8":1,"receipt-template":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"3rd-libs":"3rd-libs","MyProfile":"MyProfile","notifications":"notifications","design":"design","default~edit-item-mod~4fd868ff":"default~edit-item-mod~4fd868ff","superadmin-accounts":"superadmin-accounts","superadmin-finance":"superadmin-finance","default~addons~cloud-~ff286050":"default~addons~cloud-~ff286050","addons":"addons","integrations":"integrations","ordering":"ordering","my-menu":"my-menu","cloud":"cloud","surveys":"surveys","modifiers":"modifiers","coupons":"coupons","bulk-menu":"bulk-menu","custom-inputs":"custom-inputs","dashboard-api":"dashboard-api","default~google~map":"default~google~map","google":"google","design-localizations":"design-localizations","domain":"domain","dynamicLinks":"dynamicLinks","feather":"feather","kitchen":"kitchen","lang-az-json":"lang-az-json","lang-bg-json":"lang-bg-json","lang-bn-BD-json":"lang-bn-BD-json","lang-ca-json":"lang-ca-json","lang-de-json":"lang-de-json","lang-el-json":"lang-el-json","lang-es-json":"lang-es-json","lang-et-json":"lang-et-json","lang-fa-json":"lang-fa-json","lang-fi-json":"lang-fi-json","lang-fil-json":"lang-fil-json","lang-fr-json":"lang-fr-json","lang-ha-json":"lang-ha-json","lang-hi-json":"lang-hi-json","lang-hr-json":"lang-hr-json","lang-hu-json":"lang-hu-json","lang-hy-json":"lang-hy-json","lang-it-json":"lang-it-json","lang-ja-json":"lang-ja-json","lang-ka-json":"lang-ka-json","lang-kk-json":"lang-kk-json","lang-km-json":"lang-km-json","lang-ko-json":"lang-ko-json","lang-ku-json":"lang-ku-json","lang-lo-json":"lang-lo-json","lang-mn-json":"lang-mn-json","lang-ms-json":"lang-ms-json","lang-nb-json":"lang-nb-json","lang-nl-json":"lang-nl-json","lang-pl-json":"lang-pl-json","lang-pt-json":"lang-pt-json","lang-ro-json":"lang-ro-json","lang-ru-json":"lang-ru-json","lang-sq-json":"lang-sq-json","lang-sv-json":"lang-sv-json","lang-th-json":"lang-th-json","lang-ur-json":"lang-ur-json","lang-vi-json":"lang-vi-json","lang-zh-json":"lang-zh-json","multiselect":"multiselect","ok-table":"ok-table","b2b":"b2b","superadmin-addons":"superadmin-addons","superadmin-integrations":"superadmin-integrations","superadmin-marketing":"superadmin-marketing","qr":"qr","superadmin":"superadmin","date-picker":"date-picker","statistics":"statistics","default~billing~super~e4f9bc0f":"default~billing~super~e4f9bc0f","discounts":"discounts","reports":"reports","inventory":"inventory","clients":"clients","queues":"queues","reservations":"reservations","default~cloud-input~pos":"default~cloud-input~pos","pos":"pos","taxes":"taxes","phone-input":"phone-input","billing":"billing","refunds":"refunds","register":"register","default~custom-inputs~f3823b4b":"default~custom-inputs~f3823b4b","newsletters":"newsletters","shifts":"shifts","validate-lang-ar-json":"validate-lang-ar-json","validate-lang-bd-json":"validate-lang-bd-json","validate-lang-es-json":"validate-lang-es-json","validate-lang-fr-json":"validate-lang-fr-json","welcome":"welcome","widget":"widget","vue-cropper":"vue-cropper","vue-color":"vue-color","map":"map","delivery":"delivery","cloud-input":"cloud-input","import-modal":"import-modal","ok-editor":"ok-editor","default~edit-category~adbc22d8":"default~edit-category~adbc22d8","edit-category-modal":"edit-category-modal","edit-item-modal":"edit-item-modal","receipt-template":"receipt-template"}[chunkId]||chunkId) + "." + {"3rd-libs":"fc9d7b7b","MyProfile":"748d812a","chunk-594d6d48":"31d6cfe0","notifications":"e2b829f6","chunk-b8565db6":"31d6cfe0","chunk-dc20c3ac":"31d6cfe0","design":"266474db","default~edit-item-mod~4fd868ff":"e702822d","superadmin-accounts":"bdb85d4d","superadmin-finance":"26055e1e","default~addons~cloud-~ff286050":"31d6cfe0","addons":"e8e06f8a","integrations":"5b0c4c0f","ordering":"da499034","my-menu":"a3f1a803","cloud":"5bb663c4","surveys":"2cfd0437","modifiers":"f71148ae","coupons":"73865c95","bulk-menu":"524fb955","custom-inputs":"7ca80542","dashboard-api":"0f7b6a5a","default~google~map":"1c6b9d44","google":"3ced5ab2","design-localizations":"d2ad991e","domain":"478aa707","dynamicLinks":"5598e741","feather":"842ba61e","kitchen":"1f2acc0f","lang-az-json":"31d6cfe0","lang-bg-json":"31d6cfe0","lang-bn-BD-json":"31d6cfe0","lang-ca-json":"31d6cfe0","lang-de-json":"31d6cfe0","lang-el-json":"31d6cfe0","lang-es-json":"31d6cfe0","lang-et-json":"31d6cfe0","lang-fa-json":"31d6cfe0","lang-fi-json":"31d6cfe0","lang-fil-json":"31d6cfe0","lang-fr-json":"31d6cfe0","lang-ha-json":"31d6cfe0","lang-hi-json":"31d6cfe0","lang-hr-json":"31d6cfe0","lang-hu-json":"31d6cfe0","lang-hy-json":"31d6cfe0","lang-it-json":"31d6cfe0","lang-ja-json":"31d6cfe0","lang-ka-json":"31d6cfe0","lang-kk-json":"31d6cfe0","lang-km-json":"31d6cfe0","lang-ko-json":"31d6cfe0","lang-ku-json":"31d6cfe0","lang-lo-json":"31d6cfe0","lang-mn-json":"31d6cfe0","lang-ms-json":"31d6cfe0","lang-nb-json":"31d6cfe0","lang-nl-json":"31d6cfe0","lang-pl-json":"31d6cfe0","lang-pt-json":"31d6cfe0","lang-ro-json":"31d6cfe0","lang-ru-json":"31d6cfe0","lang-sq-json":"31d6cfe0","lang-sv-json":"31d6cfe0","lang-th-json":"31d6cfe0","lang-ur-json":"31d6cfe0","lang-vi-json":"31d6cfe0","lang-zh-json":"31d6cfe0","multiselect":"2e35d9e4","ok-table":"bca0b30c","b2b":"dd48a3e1","superadmin-addons":"393ac49b","superadmin-integrations":"fd4a5f8c","superadmin-marketing":"1129feaa","qr":"a728bd1d","superadmin":"83f465bb","date-picker":"cb4a2e4e","statistics":"cc97e153","default~billing~super~e4f9bc0f":"c196e6b5","discounts":"ddf7e39d","reports":"089b2547","inventory":"04dde983","clients":"8b6e0ce0","queues":"a4ab2fbc","reservations":"81ef7c15","default~cloud-input~pos":"31d6cfe0","pos":"0d654de6","taxes":"f959e2ca","phone-input":"215329a6","billing":"c8d06a46","refunds":"6722d645","register":"0e7c6b54","default~custom-inputs~f3823b4b":"94650b77","newsletters":"111a85b5","shifts":"a2887bd5","validate-lang-ar-json":"7dbe8aaf","validate-lang-bd-json":"31d6cfe0","validate-lang-es-json":"31d6cfe0","validate-lang-fr-json":"31d6cfe0","welcome":"a71c04ab","widget":"ce931003","vue-cropper":"de09e9aa","vue-color":"9995ccd3","map":"71362ebc","chunk-01d6075b":"734fc8e3","delivery":"f029819b","cloud-input":"d23bb0b7","import-modal":"e17ed912","ok-editor":"64a6533d","default~edit-category~adbc22d8":"b1493340","edit-category-modal":"13fc14d2","edit-item-modal":"136f53be","chunk-0be90b42":"b4cbd9f9","chunk-2170a6e2":"084d4940","chunk-79ad76c2":"4c539438","chunk-8a6fc05c":"3651be23","chunk-5daf2e3a":"7014f582","chunk-6ec23fa8":"c4c1039b","receipt-template":"6dd4c95f"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}

 		// chunk preloadng for javascript

 		var chunkPreloadMap = {
 			"MyProfile": [
 				"phone-input"
 			],
 			"design": [
 				"phone-input"
 			],
 			"superadmin-accounts": [
 				"phone-input"
 			],
 			"superadmin-finance": [
 				"phone-input"
 			],
 			"addons": [
 				"phone-input"
 			],
 			"integrations": [
 				"phone-input"
 			],
 			"ordering": [
 				"phone-input"
 			],
 			"surveys": [
 				"phone-input"
 			],
 			"google": [
 				"phone-input"
 			],
 			"b2b": [
 				"phone-input"
 			],
 			"superadmin": [
 				"phone-input"
 			],
 			"inventory": [
 				"phone-input"
 			],
 			"clients": [
 				"phone-input"
 			],
 			"queues": [
 				"phone-input"
 			],
 			"reservations": [
 				"phone-input"
 			],
 			"phone-input": [
 				"phone-input"
 			],
 			"register": [
 				"phone-input"
 			],
 			"chunk-0be90b42": [
 				"phone-input"
 			],
 			"chunk-79ad76c2": [
 				"phone-input"
 			]
 		};

 		var chunkPreloadData = chunkPreloadMap[chunkId];
 		if(chunkPreloadData) {
 			chunkPreloadData.forEach(function(chunkId) {
 				if(installedChunks[chunkId] === undefined) {
 					installedChunks[chunkId] = null;
 					var link = document.createElement('link');

 					link.charset = 'utf-8';
 					if (__webpack_require__.nc) {
 						link.setAttribute("nonce", __webpack_require__.nc);
 					}
 					link.rel = "preload";
 					link.as = "script";
 					link.href = jsonpScriptSrc(chunkId);
 					document.head.appendChild(link);
 				}
 			});
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	var startupResult = (function() {
 	// add entry module to deferred list
 	deferredModules.push([0,"super-admin"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
 	})();

 	webpackJsonpCallback([[], {}, 0, ["phone-input"]]);
 	return startupResult;
